import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "site-widget-container"
}
const _hoisted_2 = {
  key: 0,
  class: "site-widget"
}
const _hoisted_3 = { class: "site-widget" }
const _hoisted_4 = { class: "content-container" }
const _hoisted_5 = {
  key: 1,
  id: "chart",
  class: "chart-width"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderWidget = _resolveComponent("HeaderWidget")!
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_NoData = _resolveComponent("NoData")!
  const _component_PieChart = _resolveComponent("PieChart")!
  const _component_ElevatedCard = _resolveComponent("ElevatedCard")!

  return (_openBlock(), _createBlock(_component_ElevatedCard, {
    widthType: _ctx.WidthType.third
  }, {
    default: _withCtx(() => [
      _createVNode(_component_HeaderWidget, {
        iconUrl: _ctx.loadIcon,
        sizeIcon: 35,
        subtitle: _ctx.$t('requestInterventionWidget.subtitle'),
        title: _ctx.widgetTitle,
        onClick: _ctx.onPressHeader
      }, null, 8, ["iconUrl", "subtitle", "title", "onClick"]),
      (_ctx.widget)
        ? (_openBlock(), _createBlock(_component_ReglePastille, {
            key: 0,
            cle: "dashboard.widgetPerimetreCommun"
          }))
        : _createCommentVNode("", true),
      (_ctx.widget)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_ctx.widget.sites == null || _ctx.widget.sites.length > 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t('multisites')), 1))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.widget.sites, (site) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: site.id,
                    class: "site-widget-item"
                  }, [
                    _createElementVNode("div", _hoisted_3, _toDisplayString(site.description), 1)
                  ]))
                }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        (!_ctx.isLoading && _ctx.noData)
          ? (_openBlock(), _createBlock(_component_NoData, {
              key: 0,
              textNoData: "widget.intervention.noData"
            }))
          : (_ctx.isEnded)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_openBlock(), _createBlock(_component_PieChart, {
                  key: _ctx.isLoading,
                  colors: [_ctx.getColorEnCours(), _ctx.getColorPlanifie(), _ctx.getColorNonPlanifie(), _ctx.getColorTraite()],
                  height: 180,
                  isLoading: _ctx.isLoading,
                  isPercentage: false,
                  labels: [
                        _ctx.$t('requestInterventionWidget.inProgress') + ' (' + _ctx.getInterventionRequestData.nbEnCours + ')',
                        _ctx.$t('requestInterventionWidget.planned') + ' (' + _ctx.getInterventionRequestData.nbPlanifie + ')',
                        _ctx.$t('requestInterventionWidget.unplanned') +
                            ' (' +
                            _ctx.getInterventionRequestData.nbNonPlanifie +
                            ')',
                        _ctx.$t('requestInterventionWidget.traitees') + ' (' + _ctx.getInterventionRequestData.nbTraite + ')',
                    ],
                  seriesValues: _ctx.series,
                  showDataLabels: true,
                  showLegend: true,
                  width: 420,
                  onDataPointClicked: _ctx.naviguerVersRecherche
                }, null, 8, ["colors", "isLoading", "labels", "seriesValues", "onDataPointClicked"]))
              ]))
            : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["widthType"]))
}